export const MODEL_ROUTE = '/lot-drug-recalls';
